export default __webpack_public_path__ + "static/pekajace-piety-f343dec9a234cc8a60bf0ed4c4df5542.png";